import { FirebaseOptions } from 'firebase/app';

const config: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: 'auth.spellcaster.education',
  projectId: 'lectio-c2268',
  storageBucket: 'lectio-c2268.appspot.com',
  messagingSenderId: '834530530172',
  appId: '1:834530530172:web:f9df769819b79add590af9',
  measurementId: 'G-0M1YED50XY',
};

export default config;
